<!-- <div fxLayout="row">
    <div fxFlex="94">
        <header>
            <mat-form-field appearance="outline">
                <input matInput aria-label="State" [formControl]="searchCtrl">
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
            <div class="accessSpan">
                <span>Create</span>
                <span>View</span>
                <span>Update</span>
            </div>
        </header>
        [id]="tableID"
        <mat-tree id="Table" class="tree" [dataSource]="dataSource1" [treeControl]="treeControl">
            <mat-tree-node @rowsAnimation *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
                menus
                <div>
                    <button mat-icon-button disabled></button>
                    <span (click)="shown(node)"> {{node?.modules[0]?.module_name}}</span>

                </div>
                <div class="checkAccess">
                    <mat-checkbox color="primary" class="checklist-leaf-node"
                        [checked]="checklistSelection.isSelected(node)" (change)="todoLeafItemSelectionToggle(node)">
                    </mat-checkbox>
                    <mat-checkbox color="primary" class="checklist-leaf-node"
                        [checked]="checklistSelection1.isSelected(node)" (change)="todoLeafItemSelectionToggle1(node)">
                    </mat-checkbox>
                    <mat-checkbox color="primary" class="checklist-leaf-node"
                        [checked]="checklistSelection2.isSelected(node)" (change)="todoLeafItemSelectionToggle2(node)">
                    </mat-checkbox>
                </div>
            </mat-tree-node>

            <mat-tree-node *matTreeNodeDef="let node; when: hasNoContent" matTreeNodePadding>
                <button mat-icon-button disabled></button>
                <mat-form-field appearance="fill">
                    <mat-label>New item...</mat-label>
                    <input matInput #itemValue placeholder="Ex. Lettuce">
                </mat-form-field>
                <button mat-button (click)="saveNode(node, itemValue.value)">Save</button>
            </mat-tree-node>

            <mat-tree-node class="accessHead" *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
                head access title models
                <div>
                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.item">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                            used to set icon name using treeControl if expanded or not>
                        </mat-icon>
                    </button>
                    <span matTreeNodeToggle> {{node.item}}</span>
                </div>
                <div class="checkAccess">

                    <mat-checkbox color="primary" [checked]="descendantsAllSelected(node)"
                        [indeterminate]="descendantsPartiallySelected(node)" (change)="todoItemSelectionToggle(node)">
                    </mat-checkbox>
                    <mat-checkbox color="primary" [checked]="descendantsAllSelected1(node)"
                        [indeterminate]="descendantsPartiallySelected1(node)" (change)="todoItemSelectionToggle1(node)">
                    </mat-checkbox>
                    <mat-checkbox color="primary" [checked]="descendantsAllSelected2(node)"
                        [indeterminate]="descendantsPartiallySelected2(node)" (change)="todoItemSelectionToggle2(node)">
                    </mat-checkbox>
                </div>
            </mat-tree-node>
        </mat-tree>
    </div>
    <div class="hoverBtn">
        <button *ngIf="edit" #Save class="save" (click)="save();openDialog()" mat-fab>
            <i class="flaticon-save"></i>
        </button>
    </div>
</div> -->

<div>
    <!-- <mat-form-field appearance="outline">
        <input matInput aria-label="State">
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field> -->
    <div class="modules" *ngFor="let modules of dataSource1?.modules; let idx=index">
        <div class="Module">
            <div fxLayout="row">
                <div fxFlex="100" style="display: flex; justify-content: space-between; align-items: center;">
                    <!-- <header> -->
                    <h6>{{modules.module_name}}</h6>
                    <div class="accessSpan">
                        <span>View</span>
                        <span>Create</span>
                        <span>Update</span>
                    </div>
                    <!-- </header> -->
                </div>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center;">
                <span class="fw-medium"> All {{modules.module_name}} access</span>
                <div class="checkAccess">
                    <mat-checkbox color="primary" class="checklist-leaf-node node1"
                        [checked]="isEveryItemInModuleSelected(idx, 'view_permission')"
                        [indeterminate]="isAnyItemInModuleSelected(idx, 'view_permission')"
                        (change)="setViewPermissionForModule($event.checked, idx)">
                    </mat-checkbox>
                    <mat-checkbox color="primary" class="checklist-leaf-node node2"
                        [checked]="isEveryItemInModuleSelected(idx, 'add_permission')"
                        [indeterminate]="isAnyItemInModuleSelected(idx, 'add_permission')"
                        (change)="setAddPermissionForModule($event.checked, idx)">
                    </mat-checkbox>
                    <mat-checkbox color="primary" class="checklist-leaf-node node3"
                        [checked]="isEveryItemInModuleSelected(idx, 'edit_permission')"
                        [indeterminate]="isAnyItemInModuleSelected(idx, 'edit_permission')"
                        (change)="setUpdatePermissionForModule($event.checked, idx)">
                    </mat-checkbox>
                </div>
            </div>

        </div>
        <div class="Menus" *ngFor="let Menus of modules?.menus; let menu_idx=index">
            <span>{{Menus.name}}</span>
            <div class="checkAccess">
                <mat-checkbox color="primary" class="checklist-leaf-node node1"
                    [ngModel]="Menus?.permissions.view_permission"
                    (ngModelChange)="changeViewPermission($event, Menus.permissions, idx, menu_idx)">
                </mat-checkbox>
                <mat-checkbox color="primary" class="checklist-leaf-node node2"
                    [ngModel]="Menus?.permissions.add_permission"
                    (ngModelChange)="changeAddPermission($event, Menus.permissions, idx, menu_idx)">
                </mat-checkbox>
                <mat-checkbox color="primary" class="checklist-leaf-node node3"
                    [ngModel]="Menus?.permissions.edit_permission"
                    (ngModelChange)="changeEditPermission($event, Menus.permissions, idx, menu_idx)">
                </mat-checkbox>
            </div>
        </div>
    </div>
</div>